import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, OnChanges } from '@angular/core';
import { INPUTNUMBER_VALUE_ACCESSOR } from 'primeng/inputnumber';

@Component({
  selector: 'hub-button',
  templateUrl: './hub-button.component.html',
  styleUrls: ['./hub-button.component.scss'],
  providers: [],
})
export class HubButtonComponent implements OnChanges {
  @Input() text?: string;
  @Input() icon?: string;
  @Input() iconColor?: string;
  @Input() backgroundColor?: string;
  @Input() iconPosition: 'left' | 'right' = 'left';
  @Input() disabled: boolean = false;
  @Input() size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' = 'md';
  @Input() style: 'primary' | 'secondary' | 'outline' | 'borderless' | 'borderless-secondary' | 'alert' | 'lavendar' | 'lavendar-solid' = 'primary';
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() loading: boolean = false;
  @Input() badgeValue: number = 0;
  @Input() badgeColor: string = '';

  @Output() buttonClick = new EventEmitter<Event>();

  @ViewChild('hubButton') hubButton!: ElementRef<HTMLElement>;
  public buttonWidth: number = 0;

  onButtonClick(event: Event): void {
    if (!this.disabled) {
      this.buttonClick.emit(event);
    }
  }

  ngOnViewInit() {
    this.calculateButtonWidth();
  }

  ngOnChanges() {
    if (this.loading && this.buttonWidth > 0 && this.hubButton && this.hubButton.nativeElement) {
      this.hubButton.nativeElement.style.setProperty('width', `${this.buttonWidth + 1}px`);
    } else {
      if (this.hubButton && this.hubButton.nativeElement && this.buttonWidth > 0) {
        this.hubButton.nativeElement.style.removeProperty('width');
      }
    }
  }

  calculateButtonWidth() {
    setTimeout(() => {
      if (this.hubButton && this.hubButton.nativeElement && this.buttonWidth === 0) {
        const buttonElement = this.hubButton.nativeElement;
        this.buttonWidth = buttonElement.clientWidth;
      }
    }, 500);
  }


  get buttonClasses(): string {
    const isIconOnly = this.icon && !this.text;
    return `hubtiger-button hubtiger-button--${this.style} hubtiger-button--${this.size} ${isIconOnly ? 'hubtiger-button--icon-only' : ''} ${this.disabled ? 'hubtiger-button--disabled' : ''}`;
  }

  get iconSize(): string {
    const iconSizes = {
      'xs': '16px',
      'sm': '20px',
      'md': '20px',
      'lg': '20px',
      'xl': '20px',
      '2xl': '24px'
    };
    return iconSizes[this.size];
  }

  get getIconColor(): string {

    if (this.iconColor && this.iconColor.startsWith('#') && this.disabled) {
      const hex = this.iconColor.slice(1);
      const r = parseInt(hex.slice(0, 2), 16);
      const g = parseInt(hex.slice(2, 4), 16);
      const b = parseInt(hex.slice(4, 6), 16);
      return `rgba(${r}, ${g}, ${b}, 0.5)`;
    }


    if (this.iconColor) {
      return this.iconColor;
    }
    if (this.disabled) {
      const rashishColor = getComputedStyle(document.documentElement)
      .getPropertyValue('--iso-radish-200')
      .trim();

      return this.style.includes('borderless-secondary') ? rashishColor :
        this.style.includes('secondary') ? "#ffffff" :
          this.style.includes('alert') ? "#ffffff" :
            this.style.includes('outline') || this.style.includes('borderless') ? '#d1d1d1' : '#ffffff';
    }

    switch (this.style) {
      case 'primary':
      case 'secondary':
        return '#ffffff';
      case 'outline':
        return 'var(--hubtiger-primary)';
      case 'borderless':
        return 'var(--hubtiger-primary)';
      case 'borderless-secondary':
        return 'var(--iso-radish-500)';
      case 'alert':
        return '#ffffff';
      case 'lavendar':
        return '#6D5CEB';
      case 'lavendar-solid':
        return '#ffffff';
      default:
        return '#ffffff';
    }
  }
}